import { ReactNode } from "react";

import Filters from "components/Filters";
import FiltersContentWrapper from "components/Filters/ContentWrapper";
import FiltersMobileTriggerButton from "components/Filters/MobileTriggerButton";
import FiltersSidebar from "components/Filters/Sidebar";
import FiltersSplit from "components/Filters/Split";
import { FilterItem, FiltersItemsOptionsMap, SortOption } from "components/Filters/types";
import SearchInput from "components/SearchInput";
import ViewHeaderWrapper from "components/ViewHeader/Wrapper";
import { SEARCH_PLACEHOLDERS } from "constants/searchPlaceholders";
import { SEARCH_STACK_SUGGESTIONS_DICTIONARY } from "constants/stack";
import Box from "ds/components/Box";
import PageInfoHeaderActions from "ds/components/PageInfoHeader/Actions";
import PageInfoHeaderTitle from "ds/components/PageInfoHeader/Title";
import PageInfoHeaderWrapper from "ds/components/PageInfoHeader/Wrapper";
import TooltipInfo from "ds/components/TooltipInfo";

import {
  READY_TO_MIGRATE_FILTERS_ORDER_SETTINGS_KEY,
  READY_TO_MIGRATE_FILTERS_TYPE,
  READY_TO_MIGRATE_FILTER_VARIABLES,
} from "../constants";

type OpenTofuMigrationReadyToMigrateFiltersLayoutProps = {
  children: ReactNode;
  isPageEmpty: boolean;
  filters: FilterItem[];
  sortOptions: SortOption[];
  filtersMap: FiltersItemsOptionsMap;
  filtersLoading: boolean;
};

const OpenTofuMigrationReadyToMigrateFiltersLayout = ({
  children,
  isPageEmpty,
  filters,
  sortOptions,
  filtersMap,
  filtersLoading,
}: OpenTofuMigrationReadyToMigrateFiltersLayoutProps) => (
  <>
    <PageInfoHeaderWrapper>
      <Box direction="row" align="center" gap="medium">
        <PageInfoHeaderTitle title="Ready to migrate" />
        <TooltipInfo variant="standard" widthMode="maxWidthSm">
          Stacks that run OpenTofu through the legacy Terraform vendor and can move to the native
          OpenTofu vendor.
        </TooltipInfo>
      </Box>

      {!isPageEmpty && (
        <PageInfoHeaderActions>
          <ViewHeaderWrapper direction="row" align="center">
            <SearchInput
              placeholder={SEARCH_PLACEHOLDERS.STACKS}
              filtersOrderSettingsKey={READY_TO_MIGRATE_FILTERS_ORDER_SETTINGS_KEY}
            />
            <FiltersMobileTriggerButton />
          </ViewHeaderWrapper>
        </PageInfoHeaderActions>
      )}
    </PageInfoHeaderWrapper>

    <Filters
      filters={filters}
      filtersItemsOptionsMap={filtersMap}
      filtersLoading={filtersLoading}
      sortOptions={sortOptions}
      initialSortOption={READY_TO_MIGRATE_FILTER_VARIABLES.initialSortOption}
      initialSortDirection={READY_TO_MIGRATE_FILTER_VARIABLES.initialSortDirection}
      filtersOrderSettingsKey={READY_TO_MIGRATE_FILTERS_ORDER_SETTINGS_KEY}
      filtersType={READY_TO_MIGRATE_FILTERS_TYPE}
      filtersDictionary={SEARCH_STACK_SUGGESTIONS_DICTIONARY}
      disableViews
    >
      <FiltersSplit>
        <FiltersSidebar />
        <FiltersContentWrapper>{children}</FiltersContentWrapper>
      </FiltersSplit>
    </Filters>
  </>
);

export default OpenTofuMigrationReadyToMigrateFiltersLayout;
